module.exports = __webpack_public_path__ + "media/src/application/media/logo-212a070af3fd66f228dcec883b738377.png";